(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["choose-your-carry"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('skifolk-carry-selector')) {
    class SkifolkCarrySelector extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.tabs = [...this.querySelectorAll('[data-sfcs-tab]')];
        this.panels = [...this.querySelectorAll('[data-sfcs-panel]')];
        this.abortController = new AbortController();

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.select(tab), { signal: this.abortController.signal });
          tab.addEventListener('keydown', (event) => this.handleKeys(event), { signal: this.abortController.signal });
        });

        if (this.reducedMotion || !('IntersectionObserver' in window)) {
          this.reveal();
          return;
        }

        this.classList.add('is-reveal-ready');
        this.revealObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.reveal();
            this.revealObserver.disconnect();
          },
          { threshold: 0.14 }
        );
        this.revealObserver.observe(this);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.revealObserver?.disconnect();
        delete this.dataset.initialized;
      }

      reveal() {
        this.classList.add('is-visible');
        if (this.reducedMotion) return;

        const activePanel = this.panels.find((panel) => !panel.hidden);
        if (!activePanel) return;

        requestAnimationFrame(() => activePanel.classList.add('is-entering'));
      }

      select(nextTab) {
        if (nextTab.getAttribute('aria-selected') === 'true') return;

        const panelId = nextTab.getAttribute('aria-controls');
        this.tabs.forEach((tab) => {
          const selected = tab === nextTab;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          const selected = panel.id === panelId;
          panel.classList.remove('is-entering');
          panel.hidden = !selected;
          panel.classList.toggle('is-active', selected);

          if (selected && !this.reducedMotion) {
            requestAnimationFrame(() => panel.classList.add('is-entering'));
          }
        });

        nextTab.scrollIntoView({
          behavior: this.reducedMotion ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }

      handleKeys(event) {
        const index = this.tabs.indexOf(event.currentTarget);
        let nextIndex = index;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === index) return;

        event.preventDefault();
        this.tabs[nextIndex].focus();
        this.select(this.tabs[nextIndex]);
      }

      get reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }
    }

    customElements.define('skifolk-carry-selector', SkifolkCarrySelector);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-ways-to-carry"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('two-ways-carry')) {
    class TwoWaysCarry extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.range = this.querySelector('[data-sf-family-range]');
        this.liveRegion = this.querySelector('[data-sf-family-live]');
        this.videos = [...this.querySelectorAll('video')];
        this.abortController = new AbortController();

        this.range?.addEventListener('input', (event) => this.setPosition(event.currentTarget.value), {
          signal: this.abortController.signal
        });

        if (this.reducedMotion) this.videos.forEach((video) => video.pause());
        this.observe();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
        delete this.dataset.initialized;
      }

      setPosition(value, announce = false) {
        const safeValue = Math.min(92, Math.max(8, Number(value)));
        this.style.setProperty('--sf-family-position', `${safeValue}%`);
        if (this.range) {
          this.range.value = String(safeValue);
          this.range.setAttribute('aria-valuetext', `${safeValue}% of the SKIFOLK solution visible`);
        }

        if (announce) {
          this.announce(safeValue > 50 ? 'SKIFOLK solution shown' : 'Old way shown');
        }
      }

      announce(message) {
        if (!this.liveRegion) return;
        this.liveRegion.textContent = '';
        requestAnimationFrame(() => {
          this.liveRegion.textContent = message;
        });
      }

      observe() {
        if (this.reducedMotion || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }

        this.classList.add('is-reveal-ready');
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.classList.add('is-visible');
            this.observer.disconnect();
          },
          { threshold: 0.14 }
        );
        this.observer.observe(this);
      }

      get reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }
    }

    customElements.define('two-ways-carry', TwoWaysCarry);
  }

  } catch(e) { console.error(e); }
})();
})();
